import { ZERO_FEES_CONFIG_BY_MARKET_INDEX } from 'src/constants/zeroFees';

interface Params {
	marketIndex: number;
	isPerp: boolean;
}

export function getIsZeroFeesActiveForMarket({ marketIndex, isPerp }: Params) {
	if (!isPerp) {
		return false;
	}

	return !!ZERO_FEES_CONFIG_BY_MARKET_INDEX[marketIndex]?.isActive;
}
